import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';

import { MatPaginator, MatSelectChange, MatSort, MatTableDataSource } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'

import { LoginService } from "src/app/components/Shared/Service/login_service";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import beautify from 'xml-beautifier';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: Date;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-bonushub-razorpay',
  templateUrl: './bonushub-razorpay.component.html',
  styleUrls: ['./bonushub-razorpay.component.css'],
  providers: [LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class BonushubRazorpayComponent implements OnInit {

  today = new Date();
  today1 = new Date();
  Val: string;
  hotellistproperty: any = []
  lstBooking: any = [];
  // public client: Client;
  idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  displayedColumns = ['createdatetime', 'responseDatetime', 'actual_ReqToPG', 'actual_ResFromPG', 'encrypted_Req', 'encrypted_Res', 'received_PGI_Req','send_PGI_Res'];
  apiresult: any;
  Pmscodevalue: any;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  selectedDateStore: any;
  selectedTOODateStore: any;
  filterProperty: any;
  blinkOfflineHotel: boolean;
  currentDateStore: any;
  storeHeartBeatValue: any;
  XMLName: any;
  defaultData: any;
  status: void;
  requestPayload: any;
  recordTypeArray: any;
  PMSCodeArray: any
  recordTypeData: any;
  SourceSystemData: any;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService,
    private datePipe: DatePipe) {

  }

  display: Boolean = false;
  public User: string;
  selectedDate: any = new Date(this.today.setDate(this.today.getDate()));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate()));
  todayFuture: any = new Date();
  minDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() - 30));
  isProgressing: Boolean = false;
  lstGetCMHotelsProperty: any = [];
  storePmsCode: string
  Userid: any = [];
  selectedProperty: any;
  isIDSUser: boolean;
  search: string;
  totalcount: any = 0;
  pageSize = 50;
  statusResult: string;
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems: any;
  dropdownDeptData: any
  checkTodayDate: any
  CurrentDate = new Date();
  searchBarFilter: boolean = false;

  SourceSystemArray:any

  PMSCodeRecordType:any

  hideSearchFilter() {
    this.Val = '';
    this.searchBarFilter = false
  }

  
  ngOnInit() {
    this.checkTodayDate = this.CurrentDate.getDate()
    console.log('check Today =', this.checkTodayDate)
    this.isProgressing = true;
    this.getPaymentOptionList()
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.errorMsgSubscription = true
    this.statusResult = "not sent"
    this.errorMessage = "Please Select Source System"
    this.displayContent = false
    this.dropdownSettingsDept = {
      idField: 'hotelCode',
      textField: 'hotelCode',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }
  getPaymentOptionList(){
    this.apiCallIdsService.getPaymentOptionList()
      .subscribe(
        data => {
          console.log('getPaymentOptionList Data', data)
          this.SourceSystemArray = data
          this.isProgressing = false;
        });
  }

  changeSourceSystem(data: any) {
    console.log("changeSourceSystem --->" + data);
    this.isProgressing = true;
    if (data) {
      this.selectedDeptItems = ''
      this.recordTypeData = ''
      this.errorMsgSubscription = true
      this.errorMessage = "Please Select Property and Record Type"
      this.displayContent = false
      this.apiCallIdsService.getPaymentPropRecordTypeList(data)
      .subscribe(
        data => {
          console.log('getPaymentPropRecordTypeList Data', data)
          this.PMSCodeRecordType = data
          this.dropdownDeptData = this.PMSCodeRecordType.pmsCode
          this.recordTypeArray = this.PMSCodeRecordType.recordTypes
          this.isProgressing = false;
        });
    }else{
      this.toastr.error('Sometime wrong. please check')
    }
  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
      this.Val = '';
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.totalcount = 0;
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].hotelCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.selectedDeptItems = ''
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }
  getDimensionsByFilter(propertyCode: any) {
    console.log('dropdownDeptData =', this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }


  GetLoadMethodIDSUser() {
    this.searchBarFilter = true
    this.isProgressing = true;
    this.selectedDateStore = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODateStore = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    } else {
      this.requestPayload = {
        "PMSCODE": this.Pmscodevalue,
        "SOURCESYSTEM":this.SourceSystemData,
        "RECORDTYPE":this.recordTypeData,	
        "FRMDATE": this.selectedDateStore,
        "TOODATE": this.selectedTOODateStore,
      }
      console.log('this.requestPayload =', this.requestPayload);
      this.apiCallIdsService.getBonushubRazorpaylog(this.requestPayload)
        .subscribe((data) => {
          console.log('response =', data);
          if (data.length < 1) {
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          else {
            this.errorMsgSubscription = false
            this.displayContent = true
            this.idsProductList = data;
            this.totalcount = data.length
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          }
        });
    }

  }

  Search(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { propertyCode: { toString: () => string; }; propertyName: { toString: () => string; } }) => {
      return res.propertyCode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.propertyName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if (event == '') {
      this.Val = '';
      this.totalcount = 0
      this.GetLoadMethodIDSUser()
    }
  }

  pageEvent(e: any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.GetLoadMethodIDSUser();
  }


  showXml(xmltype: any, content:any) {
    console.log(xmltype,' == ',content)
    if(xmltype == 'actual_ReqToPG' && content){
      // const xml = beautify(content);
      this.XMLName = 'Actual Req To PG'
      this.defaultData = content;
      this.display = true;
      this.isProgressing = false;
    }
    else if(xmltype == 'actual_ResFromPG' && content){
      // const xml = beautify(content);
      this.XMLName = 'Actual Res from PGI'
      this.defaultData = content;
      this.display = true;
      this.isProgressing = false;
    }
    else if(xmltype == 'encrypted_Req' && content){
      // const xml = beautify(content);
      this.XMLName = 'Encrypted Req'
      this.defaultData = content;
      this.display = true;
      this.isProgressing = false;
    }
    else if(xmltype == 'encrypted_Res' && content){
      // const xml = beautify(content);
      this.XMLName = 'Encrypted Res'
      this.defaultData = content;
      this.display = true;
      this.isProgressing = false;
    }
    else if(xmltype == 'received_PGI_Req' && content){
      // const xml = beautify(content);
      this.XMLName = 'Received PGI Req'
      this.defaultData = content;
      this.display = true;
      this.isProgressing = false;
    }
    else if(xmltype == 'send_PGI_Res' && content){
      // const xml = beautify(content);
      this.XMLName = 'Send PGI Res'
      this.defaultData = content;
      this.display = true;
      this.isProgressing = false;
    }else{
      this.toastr.error('No Data Found',"",{
        timeOut: 1000
      });
    }
    
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
}